export default __webpack_public_path__ + "7c1274fdc1c0bf29d586f3d958509872.png";